import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { getVehicleExterior } from '@services/index';
import { Exterior, VehicleGalleryParams } from 'interface';

export interface VehicleExternal360State {
  imageList: Exterior[];
  error: string | null;
  loading: boolean;
  baseImageUrl: string;
  filenamePrefix: string;
  fileExtension: string;
}
export const initialState: VehicleExternal360State = {
  imageList: [],
  error: null,
  loading: false,
  baseImageUrl: '',
  filenamePrefix: '',
  fileExtension: '',
};

export const setVehicleExterior = createAsyncThunk<
  Exterior[],
  VehicleGalleryParams
>(
  'vehicleExterior/setVehicleExterior',
  async (
    vehicleImageGalleryParams: VehicleGalleryParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await getVehicleExterior(
        vehicleImageGalleryParams.modelCode,
        vehicleImageGalleryParams.doors,
        vehicleImageGalleryParams.trim,
        vehicleImageGalleryParams.train,
        vehicleImageGalleryParams.year
      );

      return response as Exterior[];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const vehicleExteriorSlice = createSlice({
  name: 'vehicleExterior',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setVehicleExterior.fulfilled, (state, action) => {
      state.imageList = action.payload;
      state.fileExtension = '';
      state.filenamePrefix = '';
      state.baseImageUrl = '';
      state.error = null;
      state.loading = false;

      if (state.imageList && state.imageList.length > 0) {
        const image = state.imageList[0];
        const filename = image.url.substring(image.url.lastIndexOf('/') + 1);
        state.fileExtension = filename.substring(filename.lastIndexOf('.') + 1);
        const filenameprefix = filename.substring(
          0,
          filename.indexOf('_angle')
        );
        state.filenamePrefix = `${filenameprefix}_angle`;
        state.baseImageUrl = image.url.substring(0, image.url.lastIndexOf('/'));
      }
    });
    builder.addCase(setVehicleExterior.rejected, (state, action) => {
      state.imageList = [];
      state.error = action.payload as string;
      state.loading = false;
    });
    builder.addCase(setVehicleExterior.pending, (state) => {
      state.imageList = [];
      state.error = null;
      state.loading = true;
    });
  },
});

export const vehicleExterior = (state: RootState) => state.vehicleExterior;

export default vehicleExteriorSlice.reducer;
